interface IProps {
  value: number
}

const HoursCell = ({ value }: IProps) => {
  return value > 0 ? <strong>{value.toFixed(2)}</strong> : <span>{value}</span>
}

export default HoursCell
